import React from 'react'
import styles from './index.scss'

function Item() {
  return <div className={styles.item}>&nbsp;</div>
}

export default Item
